$(document).ready(function(){
  $(".top-header .nav-search .search_icon img").click(function(){
    $(".top-header .nav-search").toggleClass("active");
  });

  $(".option-sidebar").on("click", function(){
    console.log("hello");
    $(".popup-overlay, .popup-content").toggleClass("active");
  });
  
  //for cart page qty
  $(".template-cart .quantity__button").on("mouseover", function(){
    $('.dropdown-cart').css('display','none');
  });
  
  $(".template-cart .quantity__button").on("mouseleave", function(){
    $('.dropdown-cart').css('display','none');
  });
  $(".template-cart .quantity__button").on("click", function () {
     $('.dropdown-cart').css('display','none');
    var $button = $(this);
    var oldValue = $button.parent().find("input.qty").val();
    // console.log(oldValue);

    if ($button.hasClass("btn-plus")) {
      var newVal = parseFloat(oldValue) + 1;
    } 
    else {
      // Don't allow decrementing below zero
      if (oldValue > 0) {
        var newVal = parseFloat(oldValue) - 1;
      } else {
        newVal = 0;
      }
    }
    $button.parent().find("input.qty").val(newVal);
  });

 
var isALARendered;
function ALAcheck() {
  isALARendered = setInterval(function () {
    customALA()
  }, 100);
}
ALAcheck();
function customALA() {
  // console.log("in ALA");
var selector = $('.product-photo-container .wrp-product-media-slider li');
  if(selector.length > 0) {
    clearInterval(isALARendered);        
    $('.product-photo-container .wrp-product-media-slider').slick({
	 // infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        adaptiveHeight: true
    });
  }  
}



  // grid and list js============================================================


// Select the container where products are loaded
let container = document.querySelector('.col-main');

if (container) {
    // Function to update grids and image classes
    let updateProducts = () => {
        let grids = container.querySelectorAll('.products-grid');
        if (grids.length > 1) {
            let firstGrid = grids[0];
            let nextGrid = firstGrid.nextElementSibling;
            if (nextGrid && nextGrid.classList.contains('products-grid')) {
                nextGrid.classList.add('active');
            }
            firstGrid.classList.remove('active');
        }

        let divs = container.querySelectorAll('.products-grid .no_crop_image');
        divs.forEach((div) => {
            div.classList.remove('col-md-4', 'col-lg-3');
            div.classList.add('col-md-3', 'col-lg-2');
        });
    };

    // Helper function to check grid type
    let isListView = () => {
        let link = document.querySelector('.infinite-scrolling a');
        return link && link.getAttribute('data-get_grid') === 'list';
    };

    // Observe new nodes added to container
    let observer = new MutationObserver(() => {
        if (isListView()) {
            updateProducts();
        }
    });

    observer.observe(container, { childList: true, subtree: true });

    // Run update on click of infinite scroll button
    let infiniteBtn = document.querySelector('.infinite-scrolling');
    if (infiniteBtn) {
        infiniteBtn.addEventListener('click', () => {
            if (isListView()) {
                updateProducts();
            }
        });
    }
}


  // grid and list js end============================================================


// $(document).on("click", ".quantity__button.btn-minus", function () {
//   const $wrapper = $(this).closest(".wrp-qty-btn-input");
//   const $input = $wrapper.find(".quantity_input");

//   // Check if input still exists
//   if (!$input.length) return;

//   const qty = parseInt($input.val(), 10);

//   if (qty < 1) {
//     // Delay remove trigger to let current execution complete
//       const $removeBtn = $wrapper.find(".btn-remove");
//       if ($removeBtn.length) {
//         $removeBtn.trigger("click");
//       }
//   }
// });

$(document).on("click", ".quantity__button.btn-minus", function () {
  const $wrapper = $(this).closest(".wrp-qty-btn-input");
  const $input = $wrapper.find(".quantity_input");

  if (!$input.length) return;

  let qty = parseInt($input.val(), 10);

  if (!isNaN(qty)) {
    if (qty === 1) {
      // Set to 0 manually
      $input.val(0);
      qty = 0;
    }

    if (qty <= 0) {
      const $removeBtn = $wrapper.find(".btn-remove");
      if ($removeBtn.length) {
        // Slight delay just in case DOM needs to update first
        setTimeout(() => {
          $removeBtn.trigger("click");
        }, 10);
      }
    }
  }
});
  

  
  
  $(document).on("click",".dropdown-cart .close-drawer svg",function() {
    $("body").removeClass("open-cart");
  });
  $(document).on("click",".header-bottom .top-cart a.cartToggle",function() {
    event.preventDefault();
    $("body").toggleClass("open-cart");
  });

  $(".open").on("click", function(){
    $(".popup-overlay, .popup-content").addClass("active");
  });
  
  //removes the "active" class to .popup and .popup-content when the "Close" button is clicked 
  $(".close").on("click", function(){
    $(".popup-overlay, .popup-content").removeClass("active");
  });
  
  
  $(".first_btn").click(function() {
    $(".refined-widgets a").trigger("click");
  });
  $(".sec_btn").click(function() {
    $(".close").trigger("click");
  });
  
  $(".icon_dropdown_desk").on("click", function(){
   
    $(this).parent("li.dropdown").toggleClass('open_desk_menu');
    $(this).parent(".open_coll_dropdown").find(".site_desk_toggle_nav").toggleClass("hide");
    
  });
  
  $(".site-nav .threelevel-list li").each(function() {
    $(this).click(function(e){
      var bold_text = $(this).text().trim();
      localStorage.setItem('bold', bold_text);
      localStorage.getItem('bold');
      var texts = $(this).parents('.dropdown').find('.link_title').attr('data-link_title');
      console.log("texts",texts);
      localStorage.setItem('favourited', texts);
      localStorage.getItem('favourited');
    });
  });
  
  var storage_val =  localStorage.getItem('favourited');
  var storage_bold =  localStorage.getItem('bold');
  
  if(storage_bold){
    $(".site-nav .threelevel-list li").each(function( index ) {
      var bold_class = $(this).text().trim();
      if(storage_bold == bold_class ){
        $(this).addClass("active");
  
      }
    });
  }
  
  
  $( ".site-nav .link_title" ).click(function(){
    var link__head = $(this).text().trim();
    console.log("link__head",link__head);
    localStorage.setItem('favourited', link__head);
    localStorage.getItem('favourited');
  
  });
  
  var stor_val =  localStorage.getItem('favourited');
  if(stor_val){
    $(".sidebar_menu_desk li.dropdown").each(function( index ) {
      var main_class = $(this).find('span.link_title').text().trim();;
      if(stor_val == main_class){$(this).addClass('open_coll_dropdown');}
    });
  }
  
  $(".template-collection .view-mode a.grid").click(function(){
    $(".collection-block-view").addClass("active");
    $(".collection-block-view_type").removeClass("active");
  });
  $(".template-collection .view-mode a.list").click(function(){
    $(".collection-block-view").removeClass("active");
    $(".collection-block-view_type").addClass("active");
  });
  
  $(window).scroll(function(){
    var sticky = $('.sticky'),
    scroll = $(window).scrollTop();
    if (scroll >= 100) sticky.addClass('fixed');
    else sticky.removeClass('fixed');
  });
  
  
  jQuery('.swatch :radio').change(function() {
    
    // console.log("swatch change",$(this));
    // slick goto slide
    let mediaId = $(this).attr("data-media-id");
    // let slickIndex = $(`.wrp-product-media-slider .slick-slide[data-media-id="${mediaId}"]`).eq(0).attr("data-slick-index");
   // $(".wrp-product-media-slider.slick-initialized").slick('slickGoTo', slickIndex);
    
    var mix_val = '';
    $(this).closest('form').find('.swatch').each(function(){
      $(this).find('.swatch-element').each(function(){
        if($(this).find('input').is(":checked")){
          mix_val = mix_val + ' / ' + $(this).find('input').val();
          // console.log(mix_val,"mix_val");
        }
      });
    });
  
    var final_val = mix_val.substr(1);
    //console.log(final_val);
    $("#product-selectors option").each(function(){
      if($(this).text().trim() == final_val){
        var sku_get =$(this).attr("data-sku");
        $(".sku_get").text(sku_get);
  
      }
    });
    
  });
  
  $(".template-collection .view-mode a.grid").click(function(){
    $(".collection-block-view").addClass("active");
    $(".collection-block-view_type").removeClass("active");
  });
  $(".template-collection .view-mode a.list").click(function(){
    $(".collection-block-view").removeClass("active");
    $(".collection-block-view_type").addClass("active");
  });

});
// document ready -- end

// custom store locator. 
document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("click", function (event) {
    let quicksizeElem = event.target.closest(".custom-lsn-switchers");
    
    if (quicksizeElem) {
      let productCard = quicksizeElem.closest(".custom-lsn-wrapper");

      if (!productCard) return;

      document.querySelectorAll(".custom-lsn-switchers.active").forEach((elem) => {
        if (elem !== quicksizeElem) {
          elem.classList.remove("active");
        }
      });

      quicksizeElem.classList.toggle("active");
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const openerBtns = document.querySelectorAll('.popup-opener-button');
  const popupSignin = document.querySelector('.popup-signin');
  const popupOverlay = document.querySelector('.ps-overlay');
  const popupCloseButton = document.querySelector('.close-btn');

  // Guard: ensure all key elements exist
  if (!popupSignin || !popupOverlay) return;

  const openPopup = () => {
    popupSignin.classList.add('active');
    popupOverlay.classList.add('active');
  };

  const closePopup = () => {
    popupSignin.classList.remove('active');
    popupOverlay.classList.remove('active');
  };

  // Open buttons
  openerBtns.forEach(btn => btn.addEventListener('click', openPopup));

  // Close when clicking overlay or close button
  popupOverlay.addEventListener('click', closePopup);
  popupCloseButton?.addEventListener('click', closePopup);
});

